import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Select from '@jwp/ott-ui-react/src/components/Select/Select';

import styles from './SeasonSelector.module.scss';

const SeasonSelector = ({
  value,
  year,
  options,
  description,
  isLoading,
  onChange,
}: {
  onChange: (value: string) => void;
  isLoading: boolean;
  value: string | undefined;
  year: string | number | undefined;
  description: string | undefined;
  options: Array<{ value: string; label: string }>;
}) => {
  const { t } = useTranslation('video');

  return (
    <div className={styles.container}>
      <div className={styles.seasonSelect}>
        <Select
          options={options}
          name="season"
          value={value}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => onChange(e.target.value)}
          aria-label={t('common:filter_videos_by', { name: t('season') })}
        />
      </div>
      {isLoading ? (
        <>
          <p className={classNames(styles.seasonYear, styles.loading)} />
          <p className={classNames(styles.seasonDescription, styles.loading)} />
        </>
      ) : (
        <>
          {year && <p className={styles.seasonYear}>{t('season_release_year', { year })}</p>}
          {description && <p className={styles.seasonDescription}>{description}</p>}
        </>
      )}
    </div>
  );
};

export default SeasonSelector;
